import { Fetcher } from '@/api/fetcher'
import { SignupDataType } from '@/components/v1/layout/main'
import { API_URL } from '@/constants'
import { ApiHandlerResult } from '..'
import { BaseApi } from '../base'

type SignupOptionsType = {
  queryParams?: {
    redirectUrl?: string
  }
}

export class AuthApi extends BaseApi {
  constructor(fetcher: Fetcher) {
    super(fetcher)
  }

  async register(
    data: SignupDataType,
    options?: SignupOptionsType
  ): ApiHandlerResult<null> {
    try {
      const res = await this.fetcher.post(API_URL.AUTH.REGISTER, {
        body: JSON.stringify(data),
      })

      return await this.parseBodyOrThrow(res)
    } catch (err: any) {
      return [err, null]
    }
  }
}
